export const selectDirtyOrders = (state) => state.orders.dirtyOrders;
export const selectDeliveries = (state) => state.orders.deliveries;
export const selectMapPoints = (state) => state.orders.mapPoints;
export const selectLastOrderCheck = (state) => state.orders.lastCheck;
